import React from "react";
import styles from "../../styles/components/createBotStepper.module.scss";
import Icons from "../../public/assets/svg";
import CreateBotTutorial from "./CreateBotTutorial";

export default function index(props) {
  return (
    <div className={`${styles.stepperContainer} container relative`}>
       <CreateBotTutorial />
      <p className={styles.stepperHeading}>{props.editBot == true ? "Edit this Bot" : (props.rollout==true?"Create a Roll Out bot":"Create a New bot")}</p>
      <p className={styles.subHeading}>
        Enter all details in the form below to create a new bot.
      </p>
      <div className={styles.stepperBody}>
        <div className={styles.borderDiv}></div>
        <div className={styles.countWrapper}>
          <div
            className={`${styles.count}  ${props.pageNumber > 1 ? styles.active : ""
              }`}>
            <p className={styles.number}>
              {" "}
              {props.pageNumber > 1 ? <Icons name="whitetick" /> : "1"}{" "}
            </p>
            <p className={styles.text}> Initial BOT details</p>
          </div>

          <div
            className={`${styles.count} ${props.pageNumber > 2 ? styles.active : ""
              }`}
          >
            <p className={styles.number}>
              {props.pageNumber > 2 ? <Icons name="whitetick" /> : "2"}
            </p>
            <p className={styles.text}> Supporting details</p>
          </div>

          <div
            className={`${styles.count} ${props.pageNumber > 3 ? styles.active : ""
              }`}
          >
            <p className={styles.number}>
              {" "}
              {props.pageNumber > 3 ? <Icons name="whitetick" /> : "3"}
            </p>
            <p className={styles.text}> BOT delivery dates</p>
          </div>
          <div className={styles.count}>
            <p className={styles.number}>4</p>
            <p className={styles.text}>Approval</p>
          </div>
        </div>
      </div>
    </div>
  );
}
